import { render, staticRenderFns } from "./StatisticLivingPlacePanel.vue?vue&type=template&id=54956dd0&scoped=true&lang=pug&"
import script from "./StatisticLivingPlacePanel.vue?vue&type=script&lang=js&"
export * from "./StatisticLivingPlacePanel.vue?vue&type=script&lang=js&"
import style0 from "./StatisticLivingPlacePanel.vue?vue&type=style&index=0&id=54956dd0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54956dd0",
  null
  
)

export default component.exports